<div class="overlay" *ngIf="isSpinnerVisible">
  <mat-progress-spinner class="spinner" color="primary" mode="indeterminate" value="50"></mat-progress-spinner>
</div>